<template>
	<div class="pa-2">
		<B-confirm-edit-dialog
			ref="dialog"
			@on-consent="addEmployee"
		></B-confirm-edit-dialog>

		<v-form
			ref="form"
			lazy-validation>
			<v-row dense>
				<v-col
					cols="12"
					md="7">
					<!-- personal info -->
					<v-card
						class="pa-2 block-border mb-2"
						elevation="0">
						<strong class="d-block mb-2">معلومات أساسية</strong>
						<v-row align="start">
							<!-- image -->
							<v-col
								cols="6"
								sm="2">
								<v-hover>
									<template v-slot:default="{ hover }">
										<v-responsive
											:aspect-ratio="1 / 1"
											style="position: relative">
											<v-img
												src="@/assets/profile.png"
												contain></v-img>
											<v-fade-transition>
												<v-overlay
													v-if="hover"
													absolute>
													<v-btn
														class="primary"
														icon
														small
														color="white">
														<v-icon small>$edit</v-icon>
													</v-btn>
													<v-btn
														class="mx-1 error"
														icon
														small
														color="white">
														<v-icon small>$close</v-icon>
													</v-btn>
												</v-overlay>
											</v-fade-transition>
										</v-responsive>
									</template>
								</v-hover>
								<v-btn
									color="primary"
									small
									block>
									تعين صورة
								</v-btn>
							</v-col>
							<!-- infos -->
							<v-col
								cols="12"
								sm="10">
								<v-row dense>
									<!-- first name -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model="personal.firstName"
											:rules="[rules.required, rules.isString]"
											:validate-on-blur="true"
											:label="$T('personal.firstName')"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>
									<!-- name in english -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model="personal.lastName"
											:rules="[rules.required, rules.isString]"
											:validate-on-blur="true"
											:label="$T('personal.lastName')"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>
									<!-- sex -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-radio-group
											v-model="personal.sex"
											:rules="[rules.required]"
											:validate-on-blur="true"
											class="mt-1"
											row
											dense
											hide-details="auto"
											v-bind="inputsAttr">
											<v-radio
												:label="$T('personal.male')"
												:value="sex.male"></v-radio>
											<v-radio
												:label="$T('personal.female')"
												:value="sex.female"></v-radio>
										</v-radio-group>
									</v-col>
									<!-- father and mother -->
									<v-col
										class="d-flex"
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model="personal.fatherName"
											:rules="[rules.required, rules.isString]"
											:validate-on-blur="true"
											class="pe-2"
											:label="$T('personal.fatherName')"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
										<v-text-field
											v-model="personal.motherName"
											:label="$T('personal.motherName')"
											:rules="[rules.isString]"
											:validate-on-blur="true"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>
									<!-- nationality -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model.trim="personal.nationality"
											:label="$T('personal.nationality')"
											:rules="[rules.required, rules.isString]"
											:validate-on-blur="true"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>
									<!-- national id -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model="personal.nationalId"
											:rules="[rules.required, rules.nationalId]"
											:validate-on-blur="true"
											:label="$T('personal.nationalId')"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>

									<!-- state -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model="personal.state"
											:label="$T('personal.state')"
											:rules="[rules.isString]"
											:validate-on-blur="true"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>
									<!-- birth location -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model="personal.birthLocation"
											:label="$T('personal.birthLocation')"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>
									<!-- birthday -->
									<v-col
										cols="12"
										sm="6"
										md="3">
										<bee-date-picker
											:active-picker.sync="activePicker"
											v-model="personal.birthday"
											:rules="[rules.required]"
											:input-label="$T('personal.birthday')"
											outlined
											menu-picker
											:input-props="{
												outlined: true,
												dense: true,
												prependInnerIcon: '$calendar',
											}"
											no-title
											dense
											hide-details="auto"
											v-bind="inputsAttr"></bee-date-picker>
									</v-col>
									<!-- age -->
									<v-col
										cols="12"
										sm="6"
										md="1">
										<!-- v-model="personal.age" -->
										<!-- :label="$T('personal.age')" -->
										<v-text-field
											:value="calcAge"
											readonly
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
									</v-col>

									<!-- name in english -->
									<v-col
										cols="12"
										sm="6"
										md="4">
										<v-text-field
											v-model="personal.nameInEnglish"
											:rules="[rules.isString]"
											:validate-on-blur="true"
											:label="$T('personal.nameInEnglish')"
											hint="بنفس طريقة كتابته في جواز السفر"
											persistent-hint
											outlined
											dense
											v-bind="inputsAttr"></v-text-field>
									</v-col>
									<v-col md="4">
										<span class="text-caption"> </span>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-card>
					<v-card
						class="pa-2 block-border"
						elevation="0">
						<strong class="d-block mb-2">{{ $T('contactsInfo.title') }}</strong>
						<bee-handy-smart-table
							class="contact-table"
							ref="contactsTable"
							:hot-inputs="true"
							v-model="contactsInputs"
							:headers="contactsHeader"
							:items="contactsItems"
							@keypress.enter="contactsEditId === null ? addContacts() : updateContacts()"
							:items-per-page="-1"
							:data-table-props="{ disableSort: true }"
							:readonly-input-fields="inputsAttr.tableDisable"
							elevation="0"
							dense
							editable-rows
							hide-no-data-area
							show-add-row
							hide-default-header
							hide-default-footer
							fixed-header
							hide-inputs-details
							stay-in-input-fields>
							<template v-slot:input.key="{ on, attr }">
								<v-autocomplete
									v-on="on"
									v-bind="attr"
									:items="Object.values(contactsType)"></v-autocomplete>
							</template>
							<template v-slot:item.actions="{ index }">
								<div class="d-flex">
									<!-- <tooltip
										:text="$T('tooltips.edit')"
										:disabled="inputsAttr.tableDisable">
										<v-btn
											:disabled="inputsAttr.tableDisable"
											depressed
											rounded
											icon
											small
											@click="
												$refs.contactsTable.activeEditForRow(index);
												contactsEditId = contactsItems.findIndex(
													(e) => e.id === item.id,
												);
											">
											<v-icon
												size="20"
												color="edit-color">
												$edit
											</v-icon>
										</v-btn>
									</tooltip> -->
									<tooltip
										:text="$T('tooltips.delete')"
										:disabled="inputsAttr.tableDisable">
										<v-btn
											:disabled="inputsAttr.tableDisable"
											icon
											small
											@click="deleteContacts(index)">
											<v-icon
												size="20"
												color="alert">
												$delete
											</v-icon>
										</v-btn>
									</tooltip>
								</div>
							</template>
							<template v-slot:no-input.actions="{}">
								<tooltip
									:text="$T('tooltips.addRow')"
									:disabled="contactsInputs.key === null || !contactsInputs.value">
									<v-btn
										:disabled="contactsInputs.key === null || !contactsInputs.value"
										icon
										small
										color="success"
										@click="contactsEditId === null ? addContacts() : updateContacts()">
										<v-icon
											size="20"
											color="addRow">
											$addRow
										</v-icon>
									</v-btn>
								</tooltip>
							</template>
						</bee-handy-smart-table>
					</v-card>
				</v-col>
				<v-col
					cols="12"
					md="5">
					<v-card
						class="pa-2 block-border"
						elevation="0">
						<strong class="d-block mb-2">معلومات إضافية</strong>
						<!-- statues -->
						<v-row
							dense
							class="mb-1">
							<!-- miliary statue -->
							<v-col cols="12">
								<span class="text-caption text--secondary">
									{{ $T('societyStatus.militaryability') }}
								</span>
								<div class="d-block d-md-flex">
									<v-radio-group
										v-model="societyStatus.militaryability"
										:validate-on-blur="true"
										class="mt-1"
										row
										dense
										hide-details="auto"
										v-bind="inputsAttr">
										<v-radio
											:label="$T('societyStatus.militaryStatus.done')"
											:value="militaryState.performed.value"></v-radio>
										<v-radio
											:label="$T('societyStatus.militaryStatus.exempt')"
											:value="militaryState.exempt.value"></v-radio>
										<v-radio
											:label="$T('societyStatus.militaryStatus.postponed')"
											:value="militaryState.delayed.value"></v-radio>
									</v-radio-group>

									<div style="max-width: 12rem; margin-right: 10px">
										<v-text-field
											v-if="societyStatus.militaryability == militaryState.exempt"
											v-model="societyStatus.militaryStatus"
											:label="$T('societyStatus.militaryStatus.cause')"
											outlined
											dense
											hide-details="auto"
											v-bind="inputsAttr"></v-text-field>
										<bee-date-picker
											v-if="societyStatus.militaryability == militaryState.delayed"
											v-model="societyStatus.militaryStatus"
											:input-label="$T('societyStatus.militaryStatus.postponedDate')"
											outlined
											menu-picker
											:input-props="{
												outlined: true,
												dense: true,
												prependInnerIcon: '$calendar',
											}"
											no-title
											dense
											hide-details="auto"
											v-bind="inputsAttr"></bee-date-picker>
									</div>
								</div>
							</v-col>
							<!-- social statue -->
							<v-col cols="12">
								<span class="text-caption text--secondary">
									{{ $T('societyStatus.marriageability') }}
								</span>
								<div class="d-block d-md-flex">
									<v-radio-group
										v-model="societyStatus.marriageability"
										class="mt-1"
										row
										dense
										hide-details="auto"
										v-bind="inputsAttr">
										<v-radio
											:label="$T('societyStatus.marriageStatus.marriage')"
											:value="socialState.married"></v-radio>
										<v-radio
											:label="$T('societyStatus.marriageStatus.divorced')"
											:value="socialState.divorced"></v-radio>
										<v-radio
											:label="$T('societyStatus.marriageStatus.single')"
											:value="socialState.single"></v-radio>
									</v-radio-group>

									<v-text-field
										style="max-width: 9rem; margin-right: 10px"
										v-model.number="societyStatus.childNumber"
										:rules="[rules.isNumber]"
										:validate-on-blur="true"
										:label="$T('societyStatus.childNumber')"
										outlined
										dense
										hide-details="auto"
										v-bind="inputsAttr"></v-text-field>
								</div>
							</v-col>
						</v-row>

						<!-- health info -->
						<v-col
							class="border"
							cols="12"
							sm="6"
							md="12">
							<strong class="d-block mb-2">{{ $T('healthInfo.title') }}</strong>
							<!-- haveIllness -->
							<span class="font-weight-bold text-caption mt-3 d-block">{{
								$T('healthInfo.haveIllness')
							}}</span>
							<v-row dense>
								<v-col
									cols="12"
									sm="4">
									<v-radio-group
										v-model="healthInfo.haveIllness"
										class="mt-1"
										row
										dense
										hide-details="auto"
										v-bind="inputsAttr">
										<v-radio
											:label="$T('no')"
											:value="false"></v-radio>
										<v-radio
											:label="$T('yes')"
											:value="true"></v-radio>
									</v-radio-group>
								</v-col>
								<v-col
									cols="12"
									sm="8">
									<v-text-field
										v-model="healthInfo.haveIllnessDescription"
										:disabled="!healthInfo.haveIllness"
										:label="$T('healthInfo.description')"
										outlined
										dense
										hide-details="auto"
										v-bind="inputsAttr"></v-text-field>
								</v-col>
							</v-row>

							<!-- haveSurgery -->
							<span class="font-weight-bold text-caption mt-3 d-block">{{
								$T('healthInfo.haveSurgery')
							}}</span>
							<v-row dense>
								<v-col
									cols="12"
									sm="4">
									<v-radio-group
										v-model="healthInfo.haveSurgery"
										class="mt-1"
										row
										dense
										hide-details="auto"
										v-bind="inputsAttr">
										<v-radio
											:label="$T('no')"
											:value="false"></v-radio>
										<v-radio
											:label="$T('yes')"
											:value="true"></v-radio>
									</v-radio-group>
								</v-col>
								<v-col
									cols="12"
									sm="8">
									<v-text-field
										v-model="healthInfo.haveSurgeryDescription"
										:disabled="!healthInfo.haveSurgery"
										:label="$T('healthInfo.description')"
										outlined
										dense
										hide-details="auto"
										v-bind="inputsAttr"></v-text-field>
								</v-col>
							</v-row>

							<!-- haveAllergy -->
							<span class="font-weight-bold text-caption mt-3 d-block">{{
								$T('healthInfo.haveAllergy')
							}}</span>
							<v-row dense>
								<v-col
									cols="12"
									sm="4">
									<v-radio-group
										v-model="healthInfo.haveAllergy"
										class="mt-1"
										row
										dense
										hide-details="auto"
										v-bind="inputsAttr">
										<v-radio
											:label="$T('no')"
											:value="false"></v-radio>
										<v-radio
											:label="$T('yes')"
											:value="true"></v-radio>
									</v-radio-group>
								</v-col>
								<v-col
									cols="12"
									sm="8">
									<v-text-field
										v-model="healthInfo.haveAllergyDescription"
										:disabled="!healthInfo.haveAllergy"
										:label="$T('healthInfo.description')"
										outlined
										dense
										hide-details="auto"
										v-bind="inputsAttr"></v-text-field>
								</v-col>
							</v-row>

							<!-- smoking -->
							<span class="font-weight-bold text-caption mt-3 d-block">{{
								$T('healthInfo.smoking')
							}}</span>
							<v-row dense>
								<v-col
									cols="12"
									sm="4">
									<v-radio-group
										v-model="healthInfo.smoking"
										class="mt-1"
										row
										dense
										hide-details="auto"
										v-bind="inputsAttr">
										<v-radio
											:label="$T('no')"
											:value="false"></v-radio>
										<v-radio
											:label="$T('yes')"
											:value="true"></v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
						</v-col>
					</v-card>
				</v-col>

				<v-col cols="12">
					<v-textarea
						v-model="notes"
						:label="$T('inputs.notes')"
						rows="3"
						outlined
						dense
						hide-details="auto"
						v-bind="inputsAttr"
						auto-grow></v-textarea>
				</v-col>
			</v-row>
			<v-divider class="mt-4 mb-3"></v-divider>
			<div class="d-flex justify-end">
				<v-btn
					class="px-10 mx-2"
					@click="$refs.dialog.activeConfirmDialog()"
					color="success"
					:loading="loadingAddingEmployee || loadingFetchEmployee"
					:disabled="loadingAddingEmployee || loadingFetchEmployee">
					{{ employeeId ? 'تعديل ملف الموظف' : 'إنشاء ملف الموظف' }}
				</v-btn>
				<v-btn
					color="primary"
					:to="{ name: 'academic-qualifications', query: { employeeId: $route.query.employeeId } }">
					{{ $T('default-buttons.next') }}
					<v-icon right> mdi-reply </v-icon>
				</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import { contactsType, militaryState, socialState, sex } from '@/utils/enum';
import validationRules from '@/utils/validation rules';
import BConfirmEditDialog from '@/components/forms/BConfirmEditDialog'

const contactValidationEnum = {
	mobilePhone: 1,
	mobileInvalid: 2,
};

const defaultContacts = [
	{
		id: 0,
		key: contactsType.address.value,
		value: '',
	},
	{
		id: 1,
		key: contactsType.mobile.value,
		value: '',
	},
	{
		id: 2,
		key: contactsType.mobile.value,
		value: '',
	},
	{
		id: 3,
		key: contactsType.email.value,
		value: '',
	},
	{
		id: 4,
		key: contactsType.phone.value,
		value: '',
	},
];

export default {
	name: 'PersonalInfo',
	components: { BConfirmEditDialog },
	props: {
		loadingFetchEmployee: { type: Boolean },
		loadingAddingEmployee: { type: Boolean },
		employeeInfo: { type: Object, default: () => ({}) },
		employeeId: { type: String },
		editingEmployee: { type: Boolean, default: false },
		disableSave: { type: Boolean, default: false },
	},

	data() {
		return {
			// forms
			personal: {
				firstName: null,
				lastName: null,
				nameInEnglish: null,
				fatherName: null,
				motherName: null,
				sex: null,
				nationality: null,
				birthday: null,
				age: null,
				state: null,
				birthLocation: null,
				nationalId: null,
			},
			societyStatus: {
				militaryability: null,
				militaryStatus: null,
				marriageability: null,
				childNumber: null,
			},
			healthInfo: {
				haveIllness: false,
				haveSurgery: false,
				haveAllergy: false,
				smoking: false,
				haveIllnessDescription: null,
				haveSurgeryDescription: null,
				haveAllergyDescription: null,
			},
			details: [],
			notes: null,

			// contact table
			contactsInputs: {},
			contactsHeader: [
				{
					text: '',
					name: 'key',
					value: 'key',
					noNotAvailableText: true,
					setValueExpr: (value) => Object.values(contactsType).find((e) => e.value === value)?.text,
					sortable: false,
					width: 200,
				},
				{
					text: '',
					name: 'value',
					value: 'value',
					sortable: false,
					writable: true,
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					noInput: true,
					width: 20,
				},
			],
			contactsItems: defaultContacts,
			contactsCounter: defaultContacts[defaultContacts.length - 1].id,
			contactsEditId: null,

			contactValidation: [],
			rules: {
				...validationRules,
				nationalId: (value) =>
					(value?.length >= 11 && value?.length <= 13) || this.$T('validations.nationalId'),
				// militaryState: (value) =>
				// 	value === null ||
				// 	(value !== null && this.personal.sex === sex.male) ||
				// 	this.$T('validations.militaryState'),
			},

			activePicker: null,
			firstTime: true, // used for disable validation on first time

			// enums
			contactsType,
			sex,
			militaryState,
			socialState,
			contactValidationEnum
		};
	},

	watch: {
		employeeInfo() {
			this.setInfo();
		},
	},

	computed: {
		inputsAttr() {
			return {
				readonly: this.editingEmployee,
				disabled: this.editingEmployee,
				tableDisable: this.editingEmployee,
			};
		},
		// utils
		calcAge() {
			if (!this.personal.birthday) return null;
			return Math.ceil(
				(new Date().getTime() - new Date(this.personal.birthday).getTime()) /
					(1000 * 60 * 60 * 24 * 365),
			);
		},
	},

	methods: {
		setInfo() {
			this.employeeInfo.personal && (this.personal = this.employeeInfo.personal);
			this.employeeInfo.societyStatus && (this.societyStatus = this.employeeInfo.societyStatus);
			this.employeeInfo.healthInfo && (this.healthInfo = this.employeeInfo.healthInfo);
			const contacts = this.employeeInfo.contactsInfo;
			if (contacts) {
				this.contactsItems = defaultContacts.map((c) => {
					const value = contacts.find((e) => e.key === c.key);
					if (value) {
						const index = contacts.findIndex((e) => e.key === c.key);
						contacts.splice(index, 1);
						return {
							...c,
							value: value.value,
						};
					} else {
						return c;
					}
				});

				contacts.forEach((e, i) => {
					this.contactsItems.push({ ...e, id: ++this.contactsCounter });
				});
			}
			this.employeeInfo.personalNote && (this.notes = this.employeeInfo.personalNote);

			// todo:clean code replace disableSave
			if (!this.firstTime || this.disableSave)
				this.$nextTick(() => {
					this.$refs.form.validate();
				});
		},
		getInfos() {
			this.$refs.form.validate();
			return {
				validation: {
					for: 1,
					count: this.$refs.form.inputs.filter((input) => !input.validate(true)).length,
				},
				data: {
					personal: this.personal,
					societyStatus: this.societyStatus,
					healthInfo: this.healthInfo,
					contactsInfo: this.contactsItems,
					personalNote: this.notes,
				},
			};
		},
		addEmployee() {
			this.$refs.dialog.deactivateConfirmDialog()
			this.$emit('add-employee', this.getInfos().data)
		},

		validateContact() {
			this.contactValidation = [];
			const key = this.contactsInputs.key;
			const value = this.contactsInputs.value;

			if (key === null || !value) return false;

			if (key === this.contactsType.mobile.value && (!Number(value) || value.length !== 10)) {
				this.contactValidation.push(contactValidationEnum.mobilePhone);
			}
			if (key === this.contactsType.mobile.value && value.slice(0, 2) !== '09') {
				this.contactValidation.push(contactValidationEnum.mobileInvalid);
			}

			if (this.contactValidation.length) {
				let error = '';
				if (this.contactValidation.includes(contactValidationEnum.mobilePhone))
					error += this.$T('validations.mobilePhone');
				if (this.contactValidation.includes(contactValidationEnum.mobileInvalid))
					error += this.$T('validations.mobileInvalid');

				this.$eventBus.$emit('show-snackbar', error, {
					error: true,
				});
				return false;
			}
			return true;
		},
		addContacts() {
			if (!this.validateContact()) return;

			this.contactsItems.push({ ...this.contactsInputs, id: ++this.contactsCounter });
			this.$refs.contactsTable.resetInputs();
			this.$refs.contactsTable.resetInputsFocus();
		},
		updateContacts() {
			if (!this.validateContact()) return;

			this.contactsItems[this.contactsEditId].key = this.contactsInputs.key;
			this.contactsItems[this.contactsEditId].value = this.contactsInputs.value;
			this.contactsEditId = null;
			this.$refs.contactsTable.resetEdit();
			this.$refs.contactsTable.resetInputs();
			this.$refs.contactsTable.resetInputsFocus();
		},
		deleteContacts(i) {
			this.contactsItems.splice(i, 1);
		},
	},

	mounted() {
		this.setInfo();
		this.firstTime = false;
	},
};
</script>

<style lang="scss">
.contact-table .v-input {
	margin-top: 0 !important;
	margin-bottom: 6px !important;
}
</style>
